import {
  SongActionButtonsRowItems,
  SongActionButtonsRowProps,
} from 'components/SongActionButtons/components/SongActionButtonsRow';
import { Container } from './styled';

type MobileSongActionButtonsRowProps = SongActionButtonsRowProps;

const MobileSongActionButtonsRow = ({
  song,
  location,
  removeFromLibrary,
  addToLibrary,
}: MobileSongActionButtonsRowProps) => (
  <Container>
    <SongActionButtonsRowItems
      song={song}
      location={location}
      removeFromLibrary={removeFromLibrary}
      addToLibrary={addToLibrary}
    />
  </Container>
);

export default MobileSongActionButtonsRow;
